import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import {
	type LWApiPublicNetworkDnsDomainRegistrationDetailsParamsRaw,
	type LWApiPublicNetworkDnsDomainRegistrationDetailsResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/dns/domain/index.raw';

import api from 'modules/queries/api';

export const NETWORK_DNS_DOMAIN_REGISTRATION_DETAILS_QUERY_KEY =
	'/network/dns/domain/registrationDetails';

const useDomainRegistrationDetails = <
	TData = LWApiPublicNetworkDnsDomainRegistrationDetailsResultRaw,
>(
	params: LWApiPublicNetworkDnsDomainRegistrationDetailsParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicNetworkDnsDomainRegistrationDetailsResultRaw,
		ApiErrorI,
		TData
	>,
) =>
	useQuery({
		queryKey: [NETWORK_DNS_DOMAIN_REGISTRATION_DETAILS_QUERY_KEY, params],
		queryFn: () => api.network.dns.domain.apiRaw.registrationDetails(params),
		...options,
	});

export default useDomainRegistrationDetails;
